












































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import MediateApi from '@/api/mediate'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import InvestigateApi from '@/api/investigate'
import addTaskMixin from './addTaskMixin'
import { idCard } from '@/utils/validator'
import { add, bignumber } from 'mathjs'
import moment from 'moment'
let id: any = 0
import { nameLength } from '@/config/global'
import { beforeAddTask } from '@/utils/order'
import { hasValue } from '@/utils/util'

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class FirstAudit extends Mixins(addTaskMixin) {
	public taskType: any = '8'
	private visible: boolean = false
	private title: any = ''
	private txt: any = ''
	private max: number = 9999999.99
	private min: number = 0.0
	private recipientSameWithPublisher: boolean = false
	private parentOrderId: any = ''
	private feeFields: any = [
		'fee.medicalFee',
		'fee.furtherMedicalFee',
		'fee.mealsFee',
		'fee.compensation',
		'fee.caregiversFee',
		'fee.commuteFee',
		'fee.otherFee',
	]

	public afterAdd() {
		this.recipientSameWithPublisher = true
		this.setRecipient()
	}

	private onNeedChange() {
		this.afterAdd()
	}

	private onRecipientSameChange(e: any) {
		this.recipientSameWithPublisher = e.target.checked
		this.setRecipient()
	}

	private disabledDate(current: any) {
		return current && current > moment().endOf('day')
	}

	public async activated() {
		// const orderId = this.$ss.get('mediateOrderId')
		const orderId = this.$route.params.orderId
		if (orderId) {
			// 先清空上一次留下的值
			this.resetPage()
			this.parentOrderId = orderId
			const res = await TaskApi.getTaskDetail(orderId)
			const order = res.data.order
			const injured = res.data.injured
			const injuredPhoneArray: any = []
			const injuredPhone: any = []
			id = 0
			for (const item of injured.selfPhone.split(',')) {
				injuredPhoneArray.push(item)
				injuredPhone.push(id++)
			}
			this.addForm.setFieldsValue({
				caseNo: order.caseNo,
				code: {
					label: order.clinicArea,
					key: `${order.provinceCode}-${order.cityCode}-${order.countryCode}`,
				},
				ownerName: order.ownerName,
				ownerPhone: order.ownerPhone,
				injuredName: injured.name,
				injuredIdType: injured.idType,
				injuredIdNo: injured.idNo,
				injuredPhone,
			})
			this.$nextTick(() => {
				this.addForm.setFieldsValue({
					injuredPhoneArray,
				})
			})
			// this.$ss.remove('mediateOrderId')
		}
		// else {
		// 	this.$multiTab.open('/AiiTasks/TasksList')
		// 	setTimeout(() => {
		// 		this.$multiTab.close('/mediate/addOfflineMediate')
		// 	}, 200)
		// }
	}

	private setRecipient() {
		this.$nextTick(() => {
			if (this.recipientSameWithPublisher) {
				this.addForm.setFieldsValue({
					mailReceivor: this.$store.state.user.userInfo.name,
					mailReceivorPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					mailReceivor: undefined,
					mailReceivorPhone: undefined,
				})
			}
		})
	}

	private onFeeInput() {
		this.$nextTick(() => {
			const arr = this.feeFields
			let sum: any = 0
			for (const item of arr) {
				const value = this.addForm.getFieldValue(item)
				if (
					value &&
					typeof value === 'number' &&
					value <= this.max &&
					value >= this.min
				) {
					sum = add(bignumber(sum), bignumber(value)).toString()
				}
			}
			this.addForm.setFieldsValue({
				total: sum,
			})
		})
	}

	private showMedicalCharge() {
		this.title = '医疗费'
		this.txt = `<div>说明：</div>
								<div>
										按照《机动车交通事故责任强制保险条例》第三十二条“医疗机构应当参照国务院卫生主管部门组织制定的有关临床诊疗指南，抢救、治疗道路交通事故中的受伤人员”。和《机动车商业总额和保险条款》第二十五条免责条款规定：“超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的费用部分”在免责范围内。
								</div>`
		this.visible = true
	}

	private showHospital() {
		this.title = '住院伙食补助费'
		this.txt = `
							<div>计算公式为：当地住院伙食补助标准*实际住院天数（剔除挂床期）</div>
							<div>说明：</div>
							<div>1.当地住院伙食补助标准参照当地国家机关一般工作人员的出差伙食补助标准；</div>
							<div>2.挂床期指在医院住院期间未进行检查、治疗的日期。</div>
						`

		this.visible = true
	}

	public checkIdNo(rule: string, value: string, cb: any) {
		const idNo = value
		if (!idNo) {
			cb(new Error('请输入伤者证件号'))
		} else if (this.addForm.getFieldValue('idType') === '01') {
			if (!idCard(idNo)) {
				cb(new Error('请输入正确的身份证号码'))
			} else {
				cb()
			}
		} else {
			cb()
		}
	}

	private onIdTypeChange() {
		this.addForm.setFieldsValue({
			idNo: this.addForm.getFieldValue('idNo'),
		})
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields(async (err: any, values: any) => {
			if (!err) {
				// validateFields存在异步校验
				// 避免快速多次的点击创建多个相同任务
				if (this.addLoading) {
					return
				}
				const fields = [
					'medicalFee',
					'furtherMedicalFee',
					'mealsFee',
					'compensation',
					'caregiversFee',
					'commuteFee',
					'otherFee',
				]
				const some = fields.some((item: any) => {
					return hasValue(values.fee[item])
				})
				if (!some) {
					return this.$message.error(
						'请填写需要赔付给伤者的对应的费用，最少填写一项'
					)
				}
				values = cloneDeep(values)
				const codes = values.code.key.split('-')
				values.provinceCode = codes[0]
				values.cityCode = codes[1]
				values.countryCode = codes[2]
				delete values.code

				for (const item in values.fee) {
					if (!values.fee[item]) {
						delete values[item]
					}
				}

				values.parentOrderId = this.parentOrderId

				const injuredPhoneArray = this.addForm.getFieldValue(
					'injuredPhoneArray'
				)

				values.injuredPhone = injuredPhoneArray
					.reduce((arr: any, item: any) => {
						if (!isEmpty(item)) {
							arr.push(item)
						}
						return arr
					}, [])
					.join(',')
				delete values.injuredPhoneArray
				values.accidentDate = values.accidentDate.format('YYYY-MM-DD')
				values.taskType = this.taskType
				this.addLoading = true
				MediateApi.addTask(values)
					.then((data: any) => {
						this.$message.success(data.message || '发布成功')
						this.resetPage()
						this.$multiTab.closeCurrentPage()
						this.$multiTab.open('/AiiTasks/TasksList')
					})
					.finally(() => {
						this.addLoading = false
					})
			} else {
				if (err.caseNo) {
					this.caseWaring = 'error'
					this.caseHelpMes = err.caseNo.errors[0].message
				}
			}
		})
	}
}
